/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private static oktaAuth: OktaAuth;

  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {
    AuthInterceptor.oktaAuth = oktaAuth;
  }

  public static getAuthorizationHeaderValue(idToken?: string) {
    return 'Bearer ' + (idToken || AuthInterceptor.oktaAuth.getAccessToken());
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const idToken = AuthInterceptor.oktaAuth.getAccessToken();
    req = req.clone({
      headers: req.headers.set('Authorization', AuthInterceptor.getAuthorizationHeaderValue(idToken))
    });

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {

          // Throw errors on success false
          if (!event.body.success) {
            throw new Error(event.body.message);
          }
        }
        return event;
      }),
      catchError((errorResponse) => {
        if (errorResponse instanceof HttpErrorResponse && errorResponse.status === 401) {
          this.authService.loginRedirect();
        }

        if (errorResponse.error) {
          return throwError(new Error(errorResponse.error.message))
        }

        return throwError(errorResponse);
      })
    );
  }
}
